import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import ExtendContract from "./ExtendContract";
export const ShowContract = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendContract row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
